export const ScrollAnchor = {

init: function() {


    $('.js-scroll').on( 'click', function(){
        $('html, body').stop().animate({
            scrollTop: $( $(this).attr('href') ).offset().top - -50
        }, 800,);
        return false;
    });

    },

};

ScrollAnchor.init();



// WEBPACK FOOTER //
// ./src/_assets/js/modules/scrollanchor.js